module.exports = __webpack_public_path__ + "img/whitebookpicture.a6c902af.png";